import * as React from "react";
import { Link } from "gatsby";
import { Popover } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import S from "./MobileMenu.styled";
import { IGatsbyImageData } from "gatsby-plugin-image";

interface Props {
  logoImageData: IGatsbyImageData | null | undefined;
  links: {
    link: {
      title: string;
      url: string;
    };
  }[];
}

const MobileMenu: React.FC<Props> = ({
  logoImageData,
  links,
  quoteRef,
  quoteLabel,
}) => {
  return (
    <div className="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
      <div className="px-5 pt-4 flex items-center justify-between">
        <Link to="/">
          <span className="sr-only">Metlab</span>
          {logoImageData && (
            <S.Logo
              image={logoImageData}
              alt={"Metlab logga"}
              objectFit={"contain"}
              className={"h-8 w-auto sm:h-12"}
            />
          )}
        </Link>
        <div className="-mr-2">
          <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500">
            <span className="sr-only"></span>
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </Popover.Button>
        </div>
      </div>
      <div className="px-2 pt-2 pb-3 space-y-1">
        {links.map((link) => (
          <>
            {link?.link?.url && link?.link?.title && (
              <Link key={link.link.title} to={link.link.url}>
                <a className="block px-3 py-2 rounded-md text-base font-medium text-mGray-700 hover:text-metlab-500 hover:bg-gray-50 transition duration-200 ease-in-out">
                  {link.link.title}
                </a>
              </Link>
            )}
          </>
        ))}
      </div>
      {
        <Link to={"#kontakt"} onClick={(e) => quoteRef.current.showModal()}>
          <div className="px-5 py-3 text-center font-medium text-white hover:text-metlab-500 bg-metlab-500 transition duration-400 ease-in-out hover:bg-metlab-200">
            {quoteLabel}
          </div>
        </Link>
      }
    </div>
  );
};

export default MobileMenu;
